import { isValueOf } from '~/core/functions/isValueOf/isValueOf'
import { FileType } from '~/core/enums'

export const isHeic = (file: File) => {
  return isValueOf(file.type, [FileType.Heif, FileType.Heic])
}
